import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

const validate = async (values): Promise<FormikErrors<any>> =>  {
    const error: any = {
        constant: 'failed'
    }
    return error;
}

class ConstantsForm extends React.Component<any, any> {
    
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        constants: JSON.stringify(this.props.config.constants, null, 2)
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                    validate={validate}
                    enableReinitialize={true}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            label='Constants'
            name='constants'
            margin="normal"
            variant="outlined"
            placeholder={JSON.stringify({
                'key': 'value'
              }, null, 2)}
            multiline={true}
            fullWidth={true}
            rows="4"
            value={p.values.constants}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <Button style={{width: '100%'}} type="submit" color="primary">Save</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(ConstantsForm));



// WEBPACK FOOTER //
// ./src/sub-projects/salesforce/components/constants-form.tsx